import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from "./components/SidebarPlugin";
import DropDown from "./components/Dropdown.vue";
import GlobalDirectives from "./globalDirectives";
import Chartist from "chartist";
// asset imports
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "./assets/scss/material-dashboard.scss";

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import SmartTable from 'vuejs-smart-table'
import VueMask from 'v-mask'
import VueCurrencyInput from 'vue-currency-input'

const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: 'USD',  locale: 'en'}
}


// library auto imports
import "es6-promise/auto";
Vue.config.productionTip = false;
Vue.prototype.$Chartist = Chartist;
Vue.component("drop-down", DropDown);
Vue.use(VueMaterial);
Vue.use(SideBar);
Vue.use(GlobalDirectives);
Vue.use(SmartTable);
Vue.use(VueMask);
Vue.use(VueCurrencyInput, pluginOptions);

new Vue({
    router,
    store,
    render: h => h(App),
    data: {
        Chartist: Chartist
    }
}).$mount("#app");
//# sourceMappingURL=main.js.map

